import { createContext } from "react";
import { AppStore } from "../createAppStore";

export const AppStoreContext = createContext<AppStore | null>(null);
